import React, { Component } from "react";
import {withRouter} from "react-router-dom";
import axios from "axios";
import { Player } from "video-react";
import Popup from "reactjs-popup";
import {gif_hover, smartPhoneVideoTrigger} from "../images";
import "../../node_modules/video-react/dist/video-react.css";
import { STEP_THREE_URL } from "../constants/path";

class Content extends Component{
	constructor(props) {
		super(props);
		this.state = {
			content: '',
			id: props.contentid.id
		};
	}
	showHoverImg() {
		return this.hoverImg.style.display = "block";
	}
	hideHoverImg() {
		return this.hoverImg.style.display = "none";
	}
	smartPhoneVideo() {
		this.smartphonevideocontainer.style.display = "block";
		this.player.toggleFullscreen(true);
		this.player.play(true);
	}
	fullScreenHandler() {
		const fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement;
		const state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
		if( (fullscreenElement !== undefined && fullscreenElement !== null) || state ) {
			console.log("Full screen");
			// this.smartphonevideocontainer.style.display = "block";
			// this.player.toggleFullscreen(true);
			// this.player.pause(false);
		} else {
			this.smartphonevideocontainer.style.display = "none";
			this.player.toggleFullscreen(false);
			this.player.pause(true);
			console.log("Normal screen");
		}
	}
	componentWillUnmount() {
		document.body.style.overflow = "unset";
		document.removeEventListener("mozfullscreenchange", this.fullScreenHandler.bind(this), false);
		document.removeEventListener("webkitfullscreenchange", this.fullScreenHandler.bind(this), false);
		document.removeEventListener("mozfullscreenchange", this.fullScreenHandler.bind(this), false);
		document.removeEventListener("fullscreenchange", this.fullScreenHandler.bind(this), false);
	}
	componentDidMount() {
		document.addEventListener("mozfullscreenchange", this.fullScreenHandler.bind(this), false);
		document.addEventListener("webkitfullscreenchange", this.fullScreenHandler.bind(this), false);
		document.addEventListener("mozfullscreenchange", this.fullScreenHandler.bind(this), false);
		document.addEventListener("fullscreenchange", this.fullScreenHandler.bind(this), false);
		axios.get(STEP_THREE_URL)
			.then(resulte => {
				// return resulte.json();
				return resulte.data;
			}).then(data => {
				let pageNames = this.props.history.location.pathname.split("/");
				const pageName = pageNames[1];
				// const id = pageNames[2];
				const id = this.state.id;
				const numbers = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۱۰",
												 "۱۱", "۱۲", "۱۳", "۱۴", "۱۵", "۱۶", "۱۷", "۱۸", "۱۹", "۲۰"
												];
				for (let key in data) {
					if (key === pageName) {
						let contents = data[key].map((content) => {
							if (content.id === parseInt(id)) {
								return (
									<div key={content.id + 7} className="row direction-rtl mb-5">
										<div key={content.id + 6} className="col-7 text-right sidebar-items-container">
											<div className="mb-0 col-12 content-text" dangerouslySetInnerHTML={{ __html : content.text }} />
											<div className="content-title mb-3 col-12">{content.title}</div>
											<div className="content-body pr-5 col-12" dangerouslySetInnerHTML={{ __html : content.description}} />
											{
												(content.example && content.example !== "") ? 
													<div className="example direction-rtl mt-4 mb-4">
														<div className="row">
															<div className="col-2 font-weight-bold text-left">مثال</div>
															<div className="col-10 example-body" dangerouslySetInnerHTML={{ __html : content.example }} />
														</div>
													</div> : 
													null
											}
											{/* <div className="content-title mb-3 col-12 mt-3">{content.manualTitle}</div> */}
											<div className="content-body pr-5 col-12" dangerouslySetInnerHTML={{ __html: content.manualText }} />
											<ul className="pr-4 mr-3 mt-3 example-body list-unstyled">
												{
													content.manualSteps.map((steps, key) => {
														return (
															<li className="step-three-manual-steps-li-numbers" key={Math.random()}>
																<span className="pl-2">{numbers[key] + "."}</span>
																<span className="step-three-manual-steps-li-text" dangerouslySetInnerHTML={{ __html: steps }} />
															</li>
														);
													})
												}
											</ul>
											{	
												(content.attention && content.attention.length !== 0) ? 
													<div className="example direction-rtl mt-3 mb-3">
														<div className="mr-5 mb-4 font-weight-bold text-right attention">توجه:</div>
														<ul className="pr-5 mr-5 example-body attention">
														{
															content.attention.map((attentionItems, key) => {
																return (
																	<li key={key}>
																		<span className="col-10 example-body" dangerouslySetInnerHTML={{ __html : attentionItems }} />
																	</li>
																)
															})
														}
														</ul>
													</div> : 
													null
											}
										</div>
										{
											( content.video ) ? 
												<div className="col-5 video-container">
												<img src={gif_hover} className="mapsa-video-gif-trigger-hover" alt="راهنمای مپسا" ref={(node) => {this.hoverImg = node}}  />
												<img
													className="smart-phone-video-player"
													onClick={this.smartPhoneVideo.bind(this)}
													src={smartPhoneVideoTrigger}
													alt="برای تماشای ویدئوی آموزشی کلیک کنید"
												/>
												<div className="smart-phone-video-container" ref={ c => {this.smartphonevideocontainer = c;} } style={{display: "none"}}>
													<Player
														ref={ c => {this.player = c;} }
														fluid={true}
														playsInline={true}
														src={content.video}
													/>
												</div>
												<Popup
													onOpen={()=>( document.body.style.overflow = "hidden" )}
													onClose={()=>( document.body.style.overflow = "unset" )}
													trigger={<img 
													src={content.gif} alt={content.title} title={content.title} className="mapsa-video-gif-trigger" onMouseEnter={this.showHoverImg.bind(this)} onMouseLeave={this.hideHoverImg.bind(this)}  />}
													modal
													closeOnDocumentClick
													contentStyle={{
														width: "100%",
														maxWidth: "100%",
														height: "90vh !important",
														backgroundImage: 'url(/help/images/popupBackground.png)',
														border: "0px solid #f0f0f0",
														backgroundPosition: "center center !important",
														backgroundRepeat: "no-repeat !important",
														backgroundSize: "cover !important",
														backgroundAttachment: "fixed !important"
													}}
												>
													{(close) => (
														<div className="container pl-0 pr-4">
															<div className="row pt-1">
																<div className="col-12 pt-3 mt-3">
																	<div className="row direction-rtl">
																		<div className="col-3 p-0">

																		</div>
																		<div className="col-8 pt-2">
																		</div>
																		<div className="col-1 mt-0">
																			<a onClick={() => (close())} href id="mapsa-video-popup-back-icon">&nbsp;</a>
																		</div>
																	</div>
																</div>
															</div>
															<div className="row justify-content-center">
																<div className="col-4 border pt-3 pb-3 video-popup-box">
																	<Player
																		playsInline
																		fluid={false}
																		height={window.innerHeight - 150}
																		width={"auto"}
																		src={content.video}
																	/>
																</div>
															</div>
														</div>
													)}
												</Popup>
											</div> : 
											null
										}
										
									</div>
								);
							}
							return false;
						});
						this.setState( {content: contents} );
					}
				}
		});
	}
	render() {
		return (
			<div>
				{this.state.content}
			</div>
		);
	}
}

export default withRouter(Content);
